import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css';
import './styles/critical.css';
import './styles/optimizations.css';

createRoot(document.getElementById("root")!).render(<App />);
